<template>
	<div class="config-content">
		<ul role="tablist" class="nav nav-tabs full">
			<li role="presentation" class="active">
				<a
					aria-controls="extra-options"
					data-toggle="tab"
					href="#extra-options"
					role="tab"
					aria-expanded="true"
					class="config-tab-option"
				>
					OPTIONS
				</a>
			</li>
		</ul>
		<div v-if="selectedColors" class="tab-content tab-content-colors">
			<div id="color-options" class="tab-pane active">
				<div class="product-data p-x">
					<div class="product-info-content">
						<div class="product-image">
							<img :src="caseImage" class="color-case">
						</div>
						<div class="about-product">
							<h5 class="text-white">{{ activeBuild && activeBuild.case && activeBuild.case.title }}</h5>
							<div class="color-selection">
								<div class="color-wrap">
									<div v-for="(color, index) in casesColorsList" :key="'part-color-' + index + '-' + color.products_id" class="color-with-price">
										<div :class="findColorInSelectedColors(color)" @click="setPartColor(color, 'case', 'empty')">
											<div
												v-if="color.images_color_logo"
												:id="color.colors ? color.colors : color.colors1.color | lowerCase"
												:style="{backgroundImage: 'url(' + color.images_color_logo + ')', height: '25px'}"
											/>
											<template v-else>
												<div :id="color.colors ? color.colors : color.colors1.color | lowerCase" class="color1"/>
												<div :id="color.colors2 ? color.colors2.color : color.colors | lowerCase" class="color2"/>
											</template>
										</div>
										<div v-if="getPrice(color, 'case')" class="color-price">{{ getPrice(color, 'case') }}</div>
										<p class="color-text-disabled" :class="`${findColorInSelectedColors(color, true)}`">Selected</p>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div v-if="motherboardColorsList && motherboardColorsList.length" class="product-data p-x">
					<div class="product-info-content">
						<div class="product-image">
							<img :src="activeBuild.motherboard.image" alt="">
						</div>
						<div class="about-product">
							<h5 class="text-white">{{ activeBuild.motherboard.title }}</h5>
							<div class="color-selection">
								<div class="color-wrap">
									<div v-for="(color, index) in motherboardColorsList" :key="'part-color-' + index + '-' + color.products_id" class="color-with-price">
										<div :class="findColorInSelectedColors(color)" @click="setPartColor(color, 'motherboard', 'empty')">
											<div
												v-if="color.images_color_logo"
												:id="color.colors ? color.colors : color.colors1.color | lowerCase"
												:style="{backgroundImage: 'url(' + color.images_color_logo + ')', height: '25px'}"
											/>
											<template v-else>
												<div :id="color.colors ? color.colors : color.colors1.color | lowerCase" class="color1"/>
												<div :id="color.colors2 ? color.colors2.color : color.colors | lowerCase" class="color2"/>
											</template>
										</div>
										<div v-if="getPrice(color, 'motherboard')" class="color-price">{{ getPrice(color, 'motherboard') }}</div>
										<p class="color-text-disabled" :class="`${findColorInSelectedColors(color, true)}`">Selected</p>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<template v-for="(caseFan, index) in caseFansColorsList">
					<div
						v-if="getBuildPartIndex(caseFan[0].products_id, 'caseFans') >= 0 && caseFan.length > 1"
						:key="'part-color-div' + index + '-' + caseFan.products_id"
						class="product-data p-x"
					>
						<div class="product-info-content">
							<div class="product-image" :class="{ 'fan-small': getCaseFan(caseFan).title.includes('120') }">
								<img :src="getCaseFan(caseFan).render" class="fan-image">
							</div>
							<div class="about-product">
								<h5 class="text-white">{{ getCaseFan(caseFan).title }}</h5>
								<div class="color-selection">
									<div class="color-wrap">
										<div v-for="(color, subIndex) in caseFan" :key="'part-color-' + subIndex + '-' + color.products_id" class="color-with-price">
											<div :class="findColorInSelectedColors(color)" @click="setPartColor(color, 'caseFans', getBuildPartIndex(caseFan[0].products_id, 'caseFans'))">
												<div :id="color.colors ? color.colors : color.colors1.color | lowerCase" class="color1"/>
												<div :id="color.colors2 ? color.colors2.color : color.colors | lowerCase" class="color2"/>
											</div>
											<div v-if="getPrice(color, 'caseFans')" class="color-price">{{ getPrice(color, 'caseFans') }}</div>
											<p class="color-text-disabled" :class="`${findColorInSelectedColors(color, true)}`">Selected</p>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</template>
				<template v-for="(extra, index) in extrasColorsList">
					<div v-if="getBuildPartIndex(extra[0].products_id, 'extras') >= 0 && extra.length > 1" :key="'part-color-div' + index + '-' + extra.products_id" class="product-data p-x">
						<div class="product-info-content">
							<div class="product-image">
								<img :src="getExtraColorImage(extra)" class="color-extras">
							</div>
							<div class="about-product">
								<h5 class="text-white">{{ activeBuild.extras[getBuildPartIndex(extra[0].products_id,'extras')].title }}</h5>
								<div class="color-selection">
									<div class="color-wrap">
										<div v-for="(color, subIndex) in extra" :key="'part-color-' + subIndex + '-' + color.products_id" class="color-with-price">
											<div :class="findColorInSelectedColors(color)" @click="setPartColor(color, 'extras', getBuildPartIndex(extra[0].products_id, 'extras'))">
												<div :id="color.colors ? color.colors : color.colors1.color | lowerCase" class="color1"/>
												<div :id="color.colors2 ? color.colors2.color : color.colors | lowerCase" class="color2"/>
											</div>
											<div v-if="getPrice(color, 'extras')" class="color-price">{{ getPrice(color, 'extras') }}</div>
											<p class="color-text-disabled" :class="`${findColorInSelectedColors(color, true)}`">Selected</p>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</template>
			</div>
		</div>
	</div>
</template>
<script>
import _cloneDeep from "lodash/cloneDeep";
import { mapGetters, mapActions, mapState } from "vuex";
import duplicate from "@m/duplicate";

export default {
	name: "ColorsTab",
	filters: {
		lowerCase(value) {
			if (!value) {
				return "";
			}

			return value.toString().toLowerCase();
		}
	},
	mixins: [
		duplicate
	],
	props: {
		colors: {
			type: Object,
			default() {
				return {};
			}
		},
		defaultSelectedColors: {
			type: Array,
			default() {
				return [];
			}
		}
	},
	data() {
		return {
			selectedColors: [],
			shouldShowScroll: false
		};
	},
	computed: {
		...mapState({
			activeBuild: state => state.Step4.activeBuild
		}),
		...mapGetters(["buildPrice"]),
		casesColorsList() {
			if (this.colors) {
				const groupedCaseColors = _.groupBy(this.colors.case, "products_id");
				return groupedCaseColors[this.activeBuild.case.products_id];
			}
			return [];
		},
		extrasColorsList() {
			if (this.colors && this.colors.extras) {
				const groupedExtrasColors = _.groupBy(this.colors.extras, "products_id");
				return groupedExtrasColors;
			}
			return [];
		},
		peripheralsColorsList() {
			const groupedPeripheralsColors = _.groupBy(this.colors.peripherals, "products_id");
			return groupedPeripheralsColors;
		},
		motherboardColorsList() {
			if (this.colors && this.colors.motherboards) {
				const groupedMotherboardColors = _.groupBy(this.colors.motherboards, "products_id");
				return groupedMotherboardColors[this.activeBuild.motherboard.products_id];
			}
			return [];
		},
		caseFansColorsList() {
			return this.colors ? _.groupBy(this.colors.caseFans || [], "products_id") : [];
		},
		caseImage() {
			const buildCase = this.activeBuild && this.activeBuild.case;
			return buildCase.render || buildCase.image;
		}
	},
	watch: {
		activeBuild() {
			this.setSelectedColors();
		}
	},
	created() {
		this.setSelectedColors();
	},
	methods: {
		...mapActions(["changeBuildPart", "setBuildPrice", "pushBuildPart", "removeBuildPart", "changeActiveRules"]),
		setSelectedColors() {
			this.selectedColors = _cloneDeep(this.activeBuild.colors);
		},
		changeBuildPrice(pricingData) {
			if (pricingData.total) {
				if (pricingData.rules) {
					this.changeActiveRules(pricingData.rules);
				}
				this.$store.dispatch("setActiveBuild", pricingData.build);
				this.setBuildPrice(pricingData.total);
			} else {
				if (pricingData.price) {
					this.setBuildPrice(pricingData.price);
				} else {
					this.setBuildPrice(pricingData);
				}
			}
		},
		getBuildPartIndex(productId, part) {
			return _.findIndex(this.activeBuild[part], {
				products_id: productId
			});
		},
		getCaseFan(fan) {
			return this.activeBuild.caseFans[this.getBuildPartIndex(fan[0].products_id, "caseFans")];
		},
		getExtraColorImage(extra) {
			const extraPart = this.activeBuild.extras[this.getBuildPartIndex(extra[0].products_id, "extras")];
			return extraPart.render || extraPart.image;
		},
		findColorInSelectedColors(selectedColor, shouldShowSelectedText) {
			const result = this.selectedColors.find((color) => {
				return color && color.products_id == selectedColor.products_id && color.id == selectedColor.id;
			});

			if (shouldShowSelectedText && result) {
				return "color-text-indicator-active";
			} else if (result) {
				return "color-wrap-option case-color swatch-color-Black-Red selected";
			} else {
				return "color-wrap-option case-color swatch-color-Black-Red";
			}
		},
		async setPartColor(color) {
			if (await this.checkOwnership()) {
				const colorIndex = _.findIndex(this.selectedColors, {
					products_id: color.products_id
				});

				if (colorIndex >= 0) {
					this.selectedColors[colorIndex] = color;
				} else {
					this.selectedColors.push(color);
				}

				axios({
					url: `/update-part-color/${color.products_id}/${color.id}?step4=true`,
					method: "GET",
					headers: {
						"token": window.CONFIG.SESSION
					}
				}).then(response => {
					this.changeBuildPrice(response.data);
				});
			} else {
				await this.duplicateBuild();
				await this.getSessionData();
				this.setPartColor(color);
			}
		},
		getPrice(color, partName) {
			const partPrice = color.price;
			let price = color.price;

			if (!price) {
				return "";
			}

			if (price == "0.00") {
				return "$" + price;
			}

			if (this.activeBuild[partName] && this.activeBuild[partName].price) {
				if (this.activeBuild[partName].quantity) {
					price = Number(partPrice) * Number(this.activeBuild[partName].quantity) - Number(this.activeBuild[
						partName]
						.price) * Number(this.activeBuild[partName].quantity);
				} else {
					price = Number(partPrice) - Number(this.activeBuild[partName].price);
				}
			} else if (Array.isArray(this.activeBuild[partName])) {
				const variantActive = this.activeBuild[partName].find(x => x.products_id == color.products_id);
				price = Number(partPrice) * Number(variantActive.quantity) - Number(variantActive.price) * Number(
					variantActive.quantity);
			}

			price = Number.parseFloat(price).toFixed(2);

			if (price == 0) {
				return "";
			}

			if (price == 0 && this.activeBuild[partName].products_id == color.products_id && this.activeBuild[
				partName].id === color.id) {
				return "";
			} else {
				if (price > -1) {
					price = `+$${price}`;
				} else {
					price = `-$${(price * -1)}`;
				}
			}

			return price;
		}
	}
};
</script>

<style lang="scss" scoped>
@import "~@s/_asset-mixers.scss";

.tab-content-colors {
    padding-right: 5px;

    @media (min-width: 991px) and (max-width: 1025px) {
        max-height: 555px;
    }

    @media (min-width: 768px) and (max-width: 991px) {
        max-height: 540px;
    }
}
    .color-text-disabled {
        display: none;
    }

    .color-text-indicator-active {
        display: block;
        color: $orchid;
        font-size: 12px;
        margin-bottom: 0;
    }

    .product-image {
        .color-case, .color-extras {
            padding: 6px !important;
        }

        .fan-image {
            padding: 20px !important;
        }
    }

    .product-image.fan-small {
        .fan-image {
            padding: 22px !important;
        }
    }
</style>
